export default [
  {
    method: 'post',
    url: '/clicky_programs/upload',
    code: 422
  }
];
